export const OBM_CAMPAIGN_TEXTS = {
    OBMPlaceHolder: 'Edit here...',
};

export const MAX_TAG_LENGTH = 22;
